import { Layout } from 'antd';

import IconLogo from '@/assets/icons/logo.svg?react';

export function RootFallback() {
  return (
    <Layout>
      <Layout.Content className="place-items-center">
        <IconLogo />
      </Layout.Content>
    </Layout>
  );
}
